import React from "react";
import { useUscLabel, useUscOptionalLabel } from "../../../../utils/labels";
import { MODAL_CONTENT } from "../../../../../../common-deprecated/utils/modalConstants";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import type { UscDispatchType } from "../../../../redux/store";
import Card from "../../styles/molecules/Card";
import Text from "../../styles/atoms/Text";
import Icon from "../../styles/Icon";
import IconWarranty from "../../assets/visuals/warranty.svg";
import Button from "../../styles/atoms/Button";
import Checkbox from "../../styles/atoms/Checkbox";
import * as CardStyles from "../../styles/molecules/Card.styles";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

/**
 * The warranty service is only shown when the vehicle has a warranty.
 * This is based on the 'vehicleHasWarranty' util inside 'getEnabledServices'
 * Therefor the warranty will currently always be shown as included
 */
const WarrantyService = (): JSX.Element => {
    const dispatch = useDispatch<UscDispatchType>();
    const [titleLabel, includedLabel] = useUscLabel(["uscServicesWarrantyTitle", "uscServicesIncluded"]);
    const [descriptionLabel, freeLabel, showMoreCtaLabel, showMoreModalTitleLabel, showMoreModalBodyLabel] =
        useUscOptionalLabel([
            "uscServicesWarrantyDescription",
            "uscServicesWarrantyFree",
            "uscServicesWarrantyShowMoreCta",
            "uscServicesWarrantyShowMoreModalTitle",
            "uscServicesWarrantyShowMoreModalBody",
        ]);

    const showMoreInfoModal = showMoreCtaLabel && showMoreModalTitleLabel && showMoreModalBodyLabel;

    return (
        <Card role="option" variant="pack" aria-selected="true">
            <CardStyles.Header>
                <div>
                    <IconWarranty />
                    <Text tag="h3" variant="h6" color="midnight">
                        {titleLabel}
                    </Text>
                </div>
                <div>
                    <Text tag="span" variant="paragraph-small-book" color="brushed-steel">
                        {includedLabel}
                    </Text>
                </div>
            </CardStyles.Header>
            <CardStyles.Body>
                {descriptionLabel && (
                    <Text tag="div" variant="paragraph-body-book" color="midnight" spacing={{ mb: "spacing-1" }}>
                        {descriptionLabel}
                    </Text>
                )}
                {showMoreInfoModal && (
                    <Button
                        variant="link"
                        size="small"
                        onClick={() => {
                            dispatch(
                                showModal({
                                    type: MODAL_CONTENT,
                                    title: showMoreModalTitleLabel,
                                    content: showMoreModalBodyLabel,
                                }),
                            );
                        }}
                    >
                        {showMoreCtaLabel}
                    </Button>
                )}
            </CardStyles.Body>
            <CardStyles.Footer>
                <div>
                    {freeLabel && (
                        <Text tag="span" variant="paragraph-body-regular" color="midnight">
                            {freeLabel}
                        </Text>
                    )}
                </div>
                <Checkbox variant="pack" id="checkbox-warranty" title={titleLabel} checked disabled>
                    <Icon variant="check" />
                </Checkbox>
            </CardStyles.Footer>
        </Card>
    );
};

export default WarrantyService;
